import { Store } from 'vuex'

const state = {
    selectedExpertIds: [],
    selectedJobExpIds: [],
    hideJobExperiencesComputed: false,
    selectAllExperts: false,
    usersExpertsObj: { data: [] },
    showAll: false,
    assignmentStatusFilterSelected: null,
    expertKeyword: "",
}

const getters = {
    selectAllExperts: state => {
        return state.selectAllExperts
    },
    assignmentStatusFilterSelected: state => {
        return state.assignmentStatusFilterSelected
    },
    userByEmail: state => email => {
        return state.usersExpertsObj.data.find(user => user.email === email)
    },
    selectedExpertIds: state => {
        return state.selectedExpertIds
    }
}

const mutations = {
    setExpertKeyword (state, keyword){
        state.expertKeyword = keyword
    },
    setSelectedExpertIds (state, selectedExpertIds) {
        state.selectedExpertIds = [...new Set(selectedExpertIds)]
    },
    setSelectedJobExpIds (state, selectedJobExpIds) {
        state.selectedJobExpIds = [...new Set(selectedJobExpIds)]
    },
    setHideJobExperiencesComputed (state, hideJobExperiencesComputed) {
        state.hideJobExperiencesComputed = hideJobExperiencesComputed
    },
    setSelectAllExperts (state, selectAllExperts) {
        state.selectAllExperts = selectAllExperts
    },
    setUsersExpertsObj (state, usersExpertsObj) {
        state.usersExpertsObj = usersExpertsObj
    },
    setShowAll (state, showAll) {
        state.showAll = showAll
    },
    updateAssigmentStatus (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                us.expert.assignments.forEach((v, i) => {
                    if (Number(payload.projectId) === Number(v.project_id) && Number(v.id) === Number(payload.assignmentId)) {
                        if (v.status) {
                            if (payload.statusName === 'Paid' && payload.value) {
                                state.usersExpertsObj.data[j].expert.assignments[i].value = payload.value
                                state.usersExpertsObj.data[j].expert.assignments[i].consult_minutes = payload.consult_minutes
                            }
                            state.usersExpertsObj.data[j].expert.assignments[i].status.name = payload.statusName
                            state.usersExpertsObj.data[j].expert.assignments[i].status.id = payload.statusId
                        }
                    }
                })
            }
        })
    },
    updateAssigmentExpertsRank (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                us.expert.assignments.forEach((v, i) => {
                    if (Number(payload.assignmentId) === Number(v.id)) {
                        if (v.status) {
                            state.usersExpertsObj.data[j].expert.assignments[i].expert_rank = payload.expertRank
                        }
                    }
                })
            }
        })
    },
    updateExpertResume (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.expert_bio.resume_url = payload.resume_url
            }
        })
    },
    updateExpertHourlyRate (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.expert_pay_info.hourly_rate = payload.hourly_rate
            }
        })
    },
    updateExpertClientCredit (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.expert_pay_info.client_credit = payload.client_credit
            }
        })
    },
    updateExpertSummary (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                us.expert.assignments.forEach((v, i) => {
                    if (Number(payload.projectId) === Number(v.project_id) && Number(v.id) === Number(payload.assignmentId)) {
                        state.usersExpertsObj.data[j].expert.assignments[i].expert_summary = payload.expert_summary
                    }
                })
            }
        })
    },
    updateExpertMainSummary (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.main_highlight = payload.main_highlight
                state.usersExpertsObj.data[j].expert.expert_bio.last_summary_update_user = payload.last_summary_update_user
                state.usersExpertsObj.data[j].expert.expert_bio.main_summary_updated_at = payload.main_summary_updated_at
            }
        })
    },
    createAssignment (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.assignments.push({
                    id: payload.assignmentId,
                    project_id: payload.projectId,
                    expert_id: payload.expertId,
                })
            }
        })
    },
    removeAssignment (state, payload) {
        state.usersExpertsObj.data.forEach((us, j) => {
            if (Number(us.expert.id) === Number(payload.expertId)) {
                state.usersExpertsObj.data[j].expert.assignments.splice(
                    state.usersExpertsObj.data[j].expert.assignments.findIndex(
                        x => x.id == payload.assignmentId),
                    1,
                )
            }
        })
    },
    setAssignmentStatusFilterSelected (state, status) {
        state.assignmentStatusFilterSelected = status
    },
}
const actions = {
    async getProjectExperts ({ dispatch, commit, state }, payload) {
        let page = 1
        if (payload.page) {
            page = payload.page
        }
        const extraString = await dispatch('getExtraString')
        const projectId = payload.projectId
        commit('setUsersExpertsObj', { data: [] })
        const url = `/admin/project/details/${projectId}`
        const response = await axios.get(
            `${url}?get_json=true&${extraString}&page=${page}`)
        commit('setUsersExpertsObj', response.data.users)
    },
    getExtraString ({ state }) {
        const params = new URLSearchParams()

        if (state.showAll) {
            params.append('display_all_results', 1)
        }

        if (state.assignmentStatusFilterSelected) {
            params.append('filter_assignment_status', state.assignmentStatusFilterSelected?.id)
        }

        if(state.expertKeyword !== "") {
            params.append('keyword', state.expertKeyword)
        }

        return params.toString()
    },
    async updateExpertData({commit}, payload){
        const expertId = payload.expertId
        const expert = (await axios.get(`/admin/experts/api/${expertId}`)).data.data

        await commit('updateExpertMainSummary', {
            expertId: expertId,
            main_highlight: expert.main_highlight,
            last_summary_update_user: expert.expert_bio.last_summary_update_user,
            main_summary_updated_at: expert.expert_bio.main_summary_updated_at,
        })

    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
